// createMessage.js
import { v4 as uuidv4 } from 'uuid';

/**
 * @typedef {'chat' | 'gift'} MessageType
 */

/**
 * @typedef {Object} MessageMedia
 * @property {string} name
 * @property {string} type
 */

/**
 * @typedef {Object} MessageData
 * @property {MessageType} type
 * @property {string} text
 * @property {string} giftId
 * @property {MessageMedia} media
 * @property {string} senderId
 * @property {string} replyOfId
 * @property {[]<string>} assetIds
 * @property {string} uploadJobId
 */

/**
 * Create a fake message
 * @param {MessageData} message
 */
const createMessage = message => {
  const {
    text,
    type,
    media,
    senderId,
    replyOfId,
    chatroomId,
    assetIds,
    uploadJobId,
  } = message;
  const postedAt = Math.floor(Date.now() / 1000);
  const id = uuidv4();

  const baseData = {
    id,
    type,
    senderId,
    postedAt,
    postedAtUnix: postedAt,
    isPending: true,
  };

  if (chatroomId) {
    baseData['chatroomId'] = chatroomId;
  }
  if (assetIds) {
    baseData['assetIds'] = assetIds;
  }
  if (uploadJobId) {
    baseData['uploadJobId'] = uploadJobId;
  }

  switch (type) {
    case 'chat':
      return {
        ...baseData,
        caption: text,
        media,
        replyOfId,
      };
    case 'gift':
      return {
        ...baseData,
        product: message.giftId,
      };
    default:
      return null;
  }
};

export default createMessage;
